import React from "react";
import PenIcon from "@/assets/pen.png";
import { SplitData } from "@/types/summary";

interface SplitSectionProps {
  data: SplitData[];
  onEdit: () => void;
}

const SplitSection: React.FC<SplitSectionProps> = ({ data, onEdit }) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };
  return (
    <div className="border-b-[1px] border-[#E2E2E2] p-[20px]">
      <div className="flex justify-between items-center mb-[16px]">
        <h3 className="text-[1.125rem]">Split</h3>
        <button
          onClick={onEdit}
          className="text-[#00ADAC] hover:text-[#008281] text-[1.125rem] cursor-pointer border-none bg-transparent flex items-center gap-1"
        >
          <img src={PenIcon} className="w-[18px] h-[18px]" alt="Edit" />
          Edit
        </button>
      </div>

      <div className="space-y-[12px]">
        {data.map((split) => (
          <div key={split.minorAccountID}>
            <p className="text-[16px]">
              {split.beneficiaryName}:{" "}
              {formatCurrency(
                split.employeeDollarAmount + split.employerDollarAmount,
              )}
            </p>
          </div>
        ))}
        {data.length === 0 && (
          <div className="text-center text-[#8B8B8B]">
            <p>No allocation splits defined.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SplitSection;
